import {
  createDomainApi,
  type ExtractEntityType,
  useApiClient,
} from '@skylabs-digital/react-proto-kit';
import {
  testInboxDeleteResultSchema,
  testInboxMessageDetailSchema,
  testInboxMessageSummarySchema,
} from '../schemas/testInbox.schema';
import { unwrap } from './unwrap';

export type {
  TestInboxDeleteResult,
  TestInboxMessageDetail,
  TestInboxMessageSummary,
} from '../schemas/testInbox.schema';

// Read-only list API (summaries)
export const testInboxApi = createDomainApi('test-inbox', testInboxMessageSummarySchema);

export type TestInboxEntity = ExtractEntityType<typeof testInboxApi>;

// Derive the full HTML viewer URL for use in iframes (no HTTP call needed)
export function getTestInboxHtmlUrl(id: string): string {
  return `/api/test-inbox/${id}/html`;
}

// Hook for detail fetch + delete actions — uses useApiClient connector (proto-kit)
export function useTestInboxActions() {
  const { connector } = useApiClient();

  const getMessage = async (id: string) => {
    const response = await connector.get<unknown>(`test-inbox/${id}`);
    return testInboxMessageDetailSchema.parse(unwrap(response));
  };

  const clearAll = async () => {
    const response = await connector.delete<unknown>('test-inbox');
    return testInboxDeleteResultSchema.parse(unwrap(response));
  };

  const clearByRecipient = async (to: string) => {
    const response = await connector.delete<unknown>(
      `test-inbox/by-recipient/${encodeURIComponent(to)}`,
    );
    return testInboxDeleteResultSchema.parse(unwrap(response));
  };

  return { getMessage, clearAll, clearByRecipient };
}
